import { styled as S, Box as x, Typography as R } from "@mui/material";
import { SsoPurpose as c } from "../../../temp-lib/constants/account.js";
import { ChainNetworkType as A } from "../../../temp-lib/constants/chain.js";
import { useAccountContext as C } from "../../../temp-lib/contexts/account/AccountContext.js";
import L from "../../../ui-lib/components/ApeironLoadingNow.js";
import { useSearchParams as T, useRouter as w } from "next/navigation";
import { useState as j, useRef as k, useEffect as P } from "react";
import { useTranslation as U } from "react-i18next";
import { jsxs as _, jsx as m } from "react/jsx-runtime";
const v = S(x)`
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, z = (d) => {
  const {
    onConnectApp: n
  } = d, {
    t: g
  } = U(), i = T(), r = i.get("code"), s = i.get("state"), t = w(), [o, h] = j(null), {
    loginByOAuth: p,
    verifyAndGetSsoState: a,
    clearLocalSsoState: l
  } = C(), f = k(!1);
  return P(() => {
    if (r || t.replace("/"), r && s && !f.current)
      try {
        const e = a(s.toString()), {
          purpose: u
        } = e;
        h(e), f.current = !0, u === c.Login ? p({
          appType: e.appType,
          authCode: r.toString(),
          redirectURI: e.redirectURI,
          network: A.Ronin
        }).then((y) => {
          y && t.replace(e.currentUrl);
        }).catch(() => {
          t.replace("/");
        }).finally(() => {
          l();
        }) : u === c.LinkApp && n && n(e, r.toString());
      } catch {
        t.replace("/");
      }
  }, [l, r, p, n, t, t.replace, s, a]), /* @__PURE__ */ _(v, {
    children: [/* @__PURE__ */ m(L, {}), (o == null ? void 0 : o.purpose) && /* @__PURE__ */ m(R, {
      children: g((o == null ? void 0 : o.purpose) === c.Login ? "sso.login.in_progress" : "sso.connect_app.in_progress")
    })]
  });
};
export {
  z as default
};
//# sourceMappingURL=SsoRedirectFlow.js.map
